import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';

export class TruckRegistrationSummaryController extends AbstractStepController {

    private timer: any;

    onContextChange(contextChange: ContextChange) { }

    onRegisterToDashboardContext() { }

    public handleFlow(): FlowStepHandleResult {

        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('summary started');

        this.timer = setTimeout(() => {
            this.finish();
        }, environment.summaryTimerSeconds * 1000);

        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();

        const spacer = new StepControl();
        spacer.type = StepControlType.SPACER_GROW;
        controls.push(spacer);

        const finishControl = new StepControl();
        finishControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.transport-registration-summary.button.finish';
        finishControl.type = StepControlType.BUTTON;
        finishControl.controlAction = this.finish.bind(this);
        controls.push(finishControl);

        return controls;
    }

    private finish() {
        clearTimeout(this.timer);
        this.wizardComponent.restartWizard();
    }
}
